"use client"

import { Box, Container, Typography, useTheme, useMediaQuery } from "@mui/material"

export default function DttFooter() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#fff",
        py: { xs: 2, sm: 3 },
        px: { xs: 2, sm: 3 },
        width: "100%",
        borderTop: "1px solid #ddd",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "center", sm: "center" },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "center", sm: "center" },
            gap: { xs: 0.5, sm: 1 },
          }}
        >
          <Typography component="span">Contact Us:</Typography>
          <Typography
            component="a"
            href="mailto:contact@pythaverse.net"
            sx={{
              color: "primary.main",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            contact@pythaverse.net
          </Typography>
        </Box>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            textAlign: { xs: "center", sm: "right" },
          }}
        >
          © {new Date().getFullYear()} Pythaverse. All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  )
}

